import { useMemo } from "react";
import { BlueBirdTheme, Button, Typography } from "@kitbird/core";
import { ArrowSwitchIcon } from "../../../../../assets/icons";
import { ModalBodyWrapper, ScrollableFormArea, SwitchIconContainer } from "./MutationUser.styled";
import UserPositionInfo from "./UserPositionInfo";
import BaseLoading from "../../../../../components/Loading/BaseLoading";
import Modal from "../../../../../components/Modal";
import { useUserPosition } from "../../Provider";

const MutationConfirmationModal = () => {
  const {
    modal,
    setModal,
    isLoadingUser,
    errorUser,
    user,
    targetUserDetail: rawIncomingUserDetail,
    handleConfirmAndSubmit,
    mutationForm,
    isSubmittingMutation,
  } = useUserPosition();
  const { formState: { isValid } } = mutationForm;
  const targetUserDetail = useMemo(() => {
    if (rawIncomingUserDetail) {
      return {
        ...rawIncomingUserDetail,
        job_title: rawIncomingUserDetail.position_info.length ? rawIncomingUserDetail.position_info[0].job_title : "-",
      };
    }
    return null;
  }, [rawIncomingUserDetail]);

  if (isLoadingUser) {
    return (
      <div style={{ padding: "1rem" }}>
        <BaseLoading />
      </div>
    );
  }

  if (errorUser) {
    return <div style={{ padding: "1rem" }}>Error fetching user</div>;
  }

  const handleCloseModal = () => {
    if (!isSubmittingMutation) setModal("");
  };

  return (
    <Modal
      width={658}
      styleBody={{ padding: "0", overflow: "hidden" }}
      title={"Konfirmasi mutasi user"}
      isOpen={modal === "CONFIRMATION_MUTATION"}
      setOpen={handleCloseModal}
      body={(
        <ModalBodyWrapper>
          <ScrollableFormArea>
            <div style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              justifyContent: "flex-start",
            }}>
              <Typography level={5} color={BlueBirdTheme.colors.gray.subtitle} fontWeight="medium">
                Apakah anda yakin ingin mengganti user berikut?
              </Typography>
              <div style={{
                display: "flex",
                gap: "1rem",
                alignItems: "center",
                justifyContent: "space-between",
              }}>
                <UserPositionInfo
                  user={user}
                  isLoading={isLoadingUser}
                  isError={errorUser}
                  variant="CONFIRMATION_INACTIVE"
                  badge={{
                    show: true,
                    backgroundColor: BlueBirdTheme.colors.gray.disable,
                    color: BlueBirdTheme.colors.white,
                    label: "Diganti",
                    position: "bottom-left",
                  }}
                />
                <SwitchIconContainer><ArrowSwitchIcon /></SwitchIconContainer>
                <UserPositionInfo
                  user={targetUserDetail}
                  variant="CONFIRMATION"
                  badge={{
                    show: true,
                    backgroundColor: BlueBirdTheme.colors.success[500],
                    color: BlueBirdTheme.colors.white,
                    label: "Yang menggantikan",
                    position: "bottom-left",
                  }}
                />
              </div>
            </div>
          </ScrollableFormArea>
        </ModalBodyWrapper>
      )}
      footer={
        <div style={{
          display: "flex",
          gap: "1.5rem",
          justifyContent: "flex-end",
        }}>
          <Button
            variant="text"
            onClick={handleCloseModal}
            disabled={isSubmittingMutation}
          >
            Batal
          </Button>
          <Button
            type="button"
            onClick={handleConfirmAndSubmit}
            disabled={!isValid || isSubmittingMutation}
          >
            {isSubmittingMutation ? "Loading..." : "Ya, Mutasi"}
          </Button>
        </div>
      }
    />
  );
};

export default MutationConfirmationModal;
